import styled from 'styled-components';
import Image from 'next/image';

type Props = {
  title: string;
  justifyContent?: 'center' | 'flex-start' | 'flex-end';
  padding?: string;
  fontSize?: string;
  fontWeight?: number;
  Icon?: SVGElement | string;
  iconHeight?: number;
  iconWidth?: number;
};

function Title({
  title,
  padding,
  justifyContent,
  fontSize,
  fontWeight,
  Icon,
  iconHeight,
  iconWidth,
}: Props) {
  const SVG = typeof Icon === 'string' ? Icon : (Icon as unknown as string);

  return (
    <ContentWrapper $padding={padding} $justifyContent={justifyContent}>
      {Icon && typeof Icon === 'function' && <SVG />}
      {Icon && typeof Icon === 'string' && (
        <Image
          width={iconWidth ?? 24}
          height={iconHeight ?? 24}
          alt={SVG}
          src={SVG}
        />
      )}

      <StyledTitle $fontSize={fontSize} $icon={!!Icon} $fontWeight={fontWeight}>
        {title}
      </StyledTitle>
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div<{
  $justifyContent?: string;
  $padding?: string;
}>`
  display: flex;
  align-items: center;

  justify-content: ${({ $justifyContent }) => $justifyContent};
  padding: ${({ $padding }) => $padding};
`;

const StyledTitle = styled.span<{
  $icon?: boolean;
  $fontSize?: string;
  $fontWeight?: number;
}>`
  text-wrap: nowrap;
  white-space: nowrap;

  font-size: ${({ $fontSize }) => $fontSize};
  font-weight: ${({ $fontWeight }) => $fontWeight};
  margin-left: ${({ $icon }) => ($icon ? '10px' : 0)};
`;

export default Title;
